import { render, staticRenderFns } from "./ResellerButtons.vue?vue&type=template&id=6bf087b2&lang=html&"
import script from "./ResellerButtons.vue?vue&type=script&lang=js&"
export * from "./ResellerButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports